import { t } from 'i18next';
import { Container, Row, Col, Button } from 'react-bootstrap';

const Error500 = () => {
  return (
    <Container fluid className="d-flex vh-100 justify-content-center align-items-center bg-light">
      <Row className="text-center">
        <Col>
          <h1 className="display-1 fw-bold text-danger">500</h1>
          <h3 className="mb-4">Internal server error.</h3>

          <p className="text-muted mb-2">
            Oh no! It seems we've encountered a hiccup. Our apologies for the inconvenience.
          </p>
          <p className="text-muted mb-5">
            Our team has been alerted and is on the case to get things back up and running smoothly.
          </p>
          <Button variant="primary" size="lg" onClick={() => window.location.reload()}>
            {t('reload')}
          </Button>
        </Col>
      </Row>
    </Container>
  );
};

export default Error500;
